export function formatDate(value: string | null | undefined) {
  if (!value) return "Not finished";
  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(new Date(value));
}

export function formatDateTime(value: string | null | undefined) {
  if (!value) return "Not recorded";
  const parts = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(new Date(value));
  const get = (type: string) =>
    parts.find((part) => part.type === type)?.value || "";
  return `${get("day")} ${get("month")} ${get("year")} at ${get("hour")}:${get("minute")}`;
}

export function toDateTimeInput(value: string | null | undefined) {
  if (!value) return "";
  const date = new Date(value);
  const pad = (part: number) => String(part).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function weightLabel(
  lbs: number | string | null | undefined,
  oz: number | string | null | undefined,
) {
  const poundsMissing = lbs === null || lbs === undefined || lbs === "";
  const ouncesMissing = oz === null || oz === undefined || oz === "";
  if (poundsMissing && ouncesMissing) return "Weight not added";

  const pounds = Number(lbs || 0);
  const ounces = Number(oz || 0);
  if (pounds === 0 && ounces === 0) return "Weight not added";
  return `${pounds} lb ${ounces} oz`;
}

export function totalWeightLabel(totalLbs: number | string | null | undefined) {
  const totalOunces = Math.round(Number(totalLbs || 0) * 16);
  const pounds = Math.floor(totalOunces / 16);
  const ounces = totalOunces % 16;
  return `${pounds} lb ${ounces} oz`;
}
